const SlashInCircleIcon = ({ color, width = '16px', height = '16px' }) => (
  <svg
    style={{ width, height }}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke={`${color || 'var(--gray-light)'}`}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.92999 4.92999L19.07 19.07"
      stroke={`${color || 'var(--gray-light)'}`}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SlashInCircleIcon;
